import VARIANTS from '~/constants/variants';

import { Condition } from './models';

export const CONDITIONS: Record<string, Condition> = {
  ...VARIANTS,
  quit: 'quit',
};

export const DEFAULT_STATE = {
  attempts: [],
  health: NaN,
};
